import { Tag } from "antd";
import { APIresponse } from "../../../model/client/response";

export const CatgoriesDetails = (categories: Array <APIresponse.CategoryDTO>) => {
    return (
        <>
        {
            categories.map((item) => 
                <Tag color={"green"}>
                    {item.name}
                </Tag>
             )
        }
        </>
    )
}